export default {
  name: 'km',
  el: {
    breadcrumb: {
      label: 'ទីតាំងនៃទំព័របច្ចុប្បន្ន',
    },
    colorpicker: {
      confirm: 'យល់ព្រម',
      clear: 'លុបចោល',
      defaultLabel: 'ឧបករណ៍ជ្រើសរើសពណ៌',
      description:
        '{color} ជាពណ៌បច្ចុប្បន្ន។ សូមចុច Enter ដើម្បីជ្រើសរើសពណ៌ថ្មី',
      alphaLabel: 'ជ្រើសរើសភាពស្រអាប់',
    },
    datepicker: {
      now: 'ឥឡូវនេះ',
      today: 'ថ្ងៃនេះ',
      cancel: 'បោះបង់',
      clear: 'លុបចោល',
      confirm: 'យល់ព្រម',
      dateTablePrompt:
        'ប្រើគ្រាប់ចុចដើម្បីរំកិល និងចុច Enter ដើម្បីជ្រើសរើសកាលបរិច្ឆេទ',
      monthTablePrompt:
        'ប្រើគ្រាប់ចុចដើម្បីរំកិល និងចុច Enter ដើម្បីជ្រើសរើសខែ',
      yearTablePrompt:
        'ប្រើគ្រាប់ចុចដើម្បីរំកិល និងចុច Enter ដើម្បីជ្រើសរើសឆ្នាំ',
      selectedDate: 'កាលបរិច្ឆេទដែលបានជ្រើសរើស',
      selectDate: 'ជ្រើសរើសកាលបរិច្ឆេទ',
      selectTime: 'ជ្រើសរើសម៉ោង',
      startDate: 'កាលបរិច្ឆេទចាប់ផ្តើម',
      startTime: 'ម៉ោងចាប់ផ្តើម',
      endDate: 'កាលបរិច្ឆេទបញ្ចប់',
      endTime: 'ម៉ោងបញ្ចប់',
      prevYear: 'ឆ្នាំមុន',
      nextYear: 'ឆ្នាំក្រោយ',
      prevMonth: 'ខែមុន',
      nextMonth: 'ខែក្រោយ',
      year: 'ឆ្នាំ',
      month1: 'ខែមករា',
      month2: 'ខែកុម្ភៈ',
      month3: 'ខែមីនា',
      month4: 'ខែមេសា',
      month5: 'ខែឧសភា',
      month6: 'ខែមិថុនា',
      month7: 'ខែកក្កដា',
      month8: 'ខែសីហា',
      month9: 'ខែកញ្ញា',
      month10: 'ខែតុលា',
      month11: 'ខែវិច្ឆិកា',
      month12: 'ខែធ្នូ',
      // week: 'សប្តាហ៍',
      weeks: {
        sun: 'អាទិត្យ',
        mon: 'ច័ន្ទ',
        tue: 'អង្គារ',
        wed: 'ពុធ',
        thu: 'ព្រហស្បតិ៍',
        fri: 'សុក្រ',
        sat: 'សៅរ៍',
      },
      weeksFull: {
        sun: 'ថ្ងៃអាទិត្យ',
        mon: 'ថ្ងៃច័ន្ទ',
        tue: 'ថ្ងៃអង្គារ',
        wed: 'ថ្ងៃពុធ',
        thu: 'ថ្ងៃព្រហស្បតិ៍',
        fri: 'ថ្ងៃសុក្រ',
        sat: 'ថ្ងៃសៅរ៍',
      },
      months: {
        jan: 'មករា',
        feb: 'កុម្ភៈ',
        mar: 'មីនា',
        apr: 'មេសា',
        may: 'ឧសភា',
        jun: 'មិថុនា',
        jul: 'កក្កដា',
        aug: 'សីហា',
        sep: 'កញ្ញា',
        oct: 'តុលា',
        nov: 'វិច្ឆិកា',
        dec: 'ធ្នូ',
      },
    },
    inputNumber: {
      decrease: 'បន្ថយតម្លៃ',
      increase: 'បង្កើនតម្លៃ',
    },
    select: {
      loading: 'កំពុងដំណើរការ',
      noMatch: 'គ្មានទិន្នន័យដែលត្រូវគ្នា',
      noData: 'គ្មានទិន្នន័យ',
      placeholder: 'សូមជ្រើសរើស',
    },
    dropdown: {
      toggleDropdown: 'បើកបិទផ្ទាំងជម្រើស',
    },
    mention: {
      loading: 'កំពុងដំណើរការ',
    },
    cascader: {
      noMatch: 'គ្មានទិន្នន័យដែលត្រូវគ្នា',
      loading: 'កំពុងដំណើរការ',
      placeholder: 'សូមជ្រើសរើស',
      noData: 'គ្មានទិន្នន័យ',
    },
    pagination: {
      goto: 'ទៅកាន់',
      pagesize: '/ទំព័រ',
      total: 'សរុប {total}',
      pageClassifier: 'ទំព័រ',
      page: 'ទំព័រ',
      prev: 'មុន',
      next: 'បន្ទាប់',
      currentPage: 'ទំព័រទី {pager}',
      prevPages: 'ទៅមុខ {pager} ទំព័រ',
      nextPages: 'ថយក្រោយ {pager} ទំព័រ',
      deprecationWarning:
        'អ្នកបានប្រើប្រាស់របស់ដែលបានផ្អាកឈប់ប្រើ សូមចូលទៅកាន់ឯកសារផ្លូវការរបស់ el-pagination សម្រាប់ព័ត៌មានបន្ថែម',
    },
    dialog: {
      close: 'បិទ',
    },
    drawer: {
      close: 'បិទ',
    },
    messagebox: {
      title: 'ជំនួយ',
      confirm: 'យល់ព្រម',
      cancel: 'បោះបង់',
      error: 'បញ្ចូលទិន្នន័យមិនត្រឹមត្រូវ!',
      close: 'បិទប្រអប់សារ',
    },
    upload: {
      deleteTip: 'ចុច Delete ដើម្បីលុបចេញ',
      delete: 'លុប',
      preview: 'មើលជាមុនសិន',
      continue: 'បន្តបញ្ជូន',
    },
    slider: {
      defaultLabel: 'ស្លាយចាប់ពី {min} ដល់ {max}',
      defaultRangeStartLabel: 'ជ្រើសរើសតម្លៃចាប់ផ្តើម',
      defaultRangeEndLabel: 'ជ្រើសរើសតម្លៃបញ្ចប់',
    },
    table: {
      emptyText: 'គ្មានទិន្នន័យ',
      confirmFilter: 'យល់ព្រម',
      resetFilter: 'កំណត់ឡើងវិញ',
      clearFilter: 'ទាំងអស់',
      sumText: 'សរុប',
    },
    tour: {
      next: 'បន្ទាប់',
      previous: 'ថយក្រោយ',
      finish: 'បញ្ចប់ការណែនាំ',
    },
    tree: {
      emptyText: 'គ្មានទិន្នន័យ',
    },
    transfer: {
      noMatch: 'គ្មានទិន្នន័យដែលត្រូវគ្នា',
      noData: 'គ្មានទិន្នន័យ',
      titles: ['បញ្ជីទី១', 'បញ្ជីទី២'],
      filterPlaceholder: 'សូមបញ្ចូលពាក្យគន្លឹះដើម្បីស្វែងរក',
      noCheckedFormat: 'ចំនួនសរុប {total}',
      hasCheckedFormat: 'ធាតុដែលបានជ្រើស {checked}/{total}',
    },
    image: {
      error: 'ការទាញយកបរាជ័យ',
    },
    pageHeader: {
      title: 'ត្រឡប់ក្រោយ',
    },
    popconfirm: {
      confirmButtonText: 'យល់ព្រម',
      cancelButtonText: 'បោះបង់',
    },
    carousel: {
      leftArrow: 'ស្លាយមុន',
      rightArrow: 'ស្លាយបន្ទាប់',
      indicator: 'ប្តូរទៅស្លាយទី {index}',
    },
  },
}
